// Loader e helper per l'elenco ufficiale ISTAT dei comuni coperti dal Protocollo.
// Il file è statico in /public/data/comuni-istat.json e può essere aggiornato senza rebuild.

let _cache = null;
let _pending = null;

export async function loadComuniIstat() {
  if (_cache) return _cache;
  if (_pending) return _pending;
  _pending = fetch("/data/comuni-istat.json")
    .then((r) => r.json())
    .then((d) => { _cache = d; return d; })
    .catch(() => ({ province: [], comuni: [] }));
  return _pending;
}

// Ritorna solo le province coperte
export async function getProvinceCoperte() {
  const d = await loadComuniIstat();
  return (d.province || []).filter((p) => p.coperto).map((p) => p.nome);
}

// Ritorna i comuni filtrati (default: solo coperti)
export async function getComuniCoperti(provincia = null) {
  const d = await loadComuniIstat();
  let list = (d.comuni || []).filter((c) => c.coperto);
  if (provincia) list = list.filter((c) => c.provincia === provincia);
  return list.map((c) => c.nome).sort((a, b) => a.localeCompare(b, "it"));
}
